export default __webpack_public_path__ + "img/cBtnjNnE.a40afd82.svg";